import Swiper from 'swiper/js/swiper.min';

export default function() {
    let windowWidth = window.innerWidth;
    let swiperSpeed = windowWidth / 3;
    let swiperDelay = 5000;

    function updateWindowWidth() {
        windowWidth = window.innerWidth;
        swiperSpeed = windowWidth / 3;
    }

    window.addEventListener('resize', updateWindowWidth);

    new Swiper('.c-entries__items', {
        watchSlidesVisibility: true,
        spaceBetween: 20,
        slidesPerView: 'auto',
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        speed: swiperSpeed,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        watchOverflow: true,
        breakpoints: {
            768: {
                spaceBetween: 40
            },
            992: {
                spaceBetween: 60
            }
        }
    });

    new Swiper('.objectoverview-image-swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });

    new Swiper('.c-slider__items', {
        spaceBetween: 0,
        slidesPerView: 1,
        autoHeight: false,
        speed: swiperSpeed,
        autoplay: {
            delay: swiperDelay
        },
        loop: true,
        navigation: {
            nextEl: '.c-slider__btn--next',
            prevEl: '.c-slider__btn--prev'
        }
    });

    new Swiper('.c-accommodations__items', {
        spaceBetween: 0,
        slidesPerView: 'auto',
        centerMode: true,
        freeMode: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });

    new Swiper('.c-widgetslider__items', {
        spaceBetween: 0,
        slidesPerView: 1,
        speed: swiperSpeed,
        autoHeight: true,
        autoplay: {
            delay: swiperDelay
        },
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });

    new Swiper('.c-footerlogos__list.swiper-container', {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: swiperDelay,
            enabled: true,
            disableOnInteraction: true
        },
        pagination: false,
        navigation: false,
        breakpoints: {
            576: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 3
            },
            1360: {
                slidesPerView: 4
            }
        }
    });

    new Swiper('#heroslider', {
        slidesPerView: 1,
        loop: false,
        speed: 1000,
        autoplay: {
            delay: 4800,
            enabled: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: false,
        navigation: false,
        on: {
            slideChange: function() {
                const indexCurrentSlide = this.realIndex;
                const currentSlide = this.slides[indexCurrentSlide];
                currentSlide.classList.remove('is-play');

                setTimeout(function() {
                    currentSlide.classList.add('is-play');
                }, 10);
            }
        }
    });
}
